import { Navigate, Outlet } from 'react-router-dom'

const PlayerProtectedRoute = () => {
  const getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }

  const hasLoginCookie = getCookie('gsk_player_login')
  const isAdminHost = window.location.hostname === 'admin.gsk.nevast.com'

  if (!hasLoginCookie && !isAdminHost) {
    return <Navigate to="/player-login" replace />
  }

  return <Outlet />
}

export default PlayerProtectedRoute
